import { HttpClient } from '@angular/common/http';
import { Component, type OnDestroy, type OnInit, inject } from '@angular/core';
import { Subscription } from 'rxjs';
import * as SeverGetInfo from '../../../server/routes/server/get-info';
import { environment } from '../../environments';
import { TitleService } from '../title.service';

@Component({
  selector: 'app-debug',
  templateUrl: './debug.component.html',
  styleUrls: ['./debug.component.scss'],
  standalone: false,
})
export class DebugComponent implements OnInit, OnDestroy {
  private http = inject(HttpClient);
  private titleService = inject(TitleService);

  appVersion: string;
  serverVersion: string;

  subscriptions = new Subscription();

  ngOnInit() {
    this.titleService.set('Debug');

    this.appVersion = environment.version;

    const sub = this.http
      .post<SeverGetInfo.ResBody>('/api/server/get-info', {})
      .subscribe((response) => {
        this.serverVersion = response.version;
      });
    this.subscriptions.add(sub);
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
